import { render } from "./HolidaysTable.vue?vue&type=template&id=8fa7f460&scoped=true"
import script from "./HolidaysTable.vue?vue&type=script&lang=js"
export * from "./HolidaysTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa7f460"]])

export default __exports__